import { Redirect } from 'react-router-dom';
import { ROUTE_PATHS } from '../../config/routes';

export const ImportFile = () => <Redirect to={`.${ROUTE_PATHS.CUSTOMERS}`} />;
